import { IUser } from 'interfaces/User';

export const checkRole = (user: IUser, role: number[]): boolean | void => {
	return role.some((item) => item === user?.role?.id);
};
